import React, { useEffect, useState } from 'react';
import '../styles/components/networkStatusBanner.css';

interface NetworkStatusBannerProps {
  isOnline: boolean;
  isSlowConnection: boolean;
}

const NetworkStatusBanner: React.FC<NetworkStatusBannerProps> = ({ isOnline, isSlowConnection }) => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!isOnline || isSlowConnection) {
      setShow(true);
    } else {
      // Delay hiding to avoid flashing
      const timer = setTimeout(() => setShow(false), 2000);
      return () => clearTimeout(timer);
    }
  }, [isOnline, isSlowConnection]);

  if (!show) return null;

  return (
    <div className={`network-status-banner ${!isOnline ? 'offline' : 'slow'}`}>
      {!isOnline ? (
        <>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M1 1l22 22M16.72 11.06A10.94 10.94 0 0119 12.55M5 12.55a10.94 10.94 0 015.17-2.39M10.71 5.05A16 16 0 0122.58 9M1.42 9a15.91 15.91 0 014.7-2.88M8.53 16.11a6 6 0 016.95 0M12 20h.01"/>
          </svg>
          <span>No internet connection</span>
        </>
      ) : (
        <>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83"/>
          </svg>
          <span>Slow connection detected</span>
        </>
      )}
    </div>
  );
};

export default NetworkStatusBanner;
